import axios from 'axios';
import { REACT_APP_BLOCKSUITE_WS_URL } from '../global/environment';
import { captureException } from './logService';
import { getAPIErrorReason } from '../helpers/common';
import { DocVersion, DocVersionList } from '../interfaces/ProjectInterface';
import { rootStore } from '../mobx/rootStore';

/**
 * @desc Doc - get doc versions list
 * @param {*}
 */
export const getDocVersionList = async (docId: string | undefined) => {
  try {
    if (!docId) return undefined;
    const response = await axios.get(`${REACT_APP_BLOCKSUITE_WS_URL}/versions?docId=${docId}`);
    const { data } = response;
    if (data) {
      return data as DocVersionList;
    }
    return undefined;
  } catch (e) {
    const error = getAPIErrorReason(e) || 'Unable to get doc version list please try again';
    captureException(error);
    dispatchCustomerError(error);
    return undefined;
  }
};

/**
 * @desc Doc - get doc version
 * @param {*}
 */
export const getDocVersion = async (versionId: string | number) => {
  try {
    const response = await axios.get(`${REACT_APP_BLOCKSUITE_WS_URL}/versions/${versionId}`);
    const { data } = response;
    if (data) {
      return data as DocVersion;
    }
    return undefined;
  } catch (e) {
    const error = getAPIErrorReason(e) || 'Unable to get doc version please try again';
    captureException(error);
    dispatchCustomerError(error);
    return undefined;
  }
};

function dispatchCustomerError(msg: string) {
  rootStore.alertNotificationStore.setErrorMessage(msg);
}
